// extracted by mini-css-extract-plugin
export default {"root":"CustomerForm_root__lGmC9","dbaContainer":"CustomerForm_dbaContainer__XYZfq","dbaRow":"CustomerForm_dbaRow__-ywVK","fullWidth":"CustomerForm_fullWidth__+t+GD"};